import type { Components, Theme } from '@mui/material';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.spacing(1),
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
    }),
    list: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      padding: theme.spacing(0.5),
    }),
  },
};
